import { useState } from 'react'
import { QuoteItemType } from '@generatedTypes/graphql'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ItemBoundingBox from '@components/atoms/ItemBoundingBox'
import FlatFeeQuoteForm, {
  FlatFeeFormData,
} from '@/view/components/molecules/FlatFeeQuoteForm'
import HourlyFeeQuoteForm, {
  HourlyFeeFormData,
} from '@/view/components/molecules/HourlyFeeQuoteForm'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const FormSelector = ({
  selectedForm,
  onChange,
}: {
  selectedForm: QuoteItemType
  onChange: (formType: QuoteItemType) => void
}) => {
  return (
    <ButtonGroup variant="outlined" aria-label="Quote type">
      <Button
        variant={
          selectedForm == QuoteItemType.Hourly ? 'contained' : 'outlined'
        }
        onClick={() => onChange(QuoteItemType.Hourly)}
      >
        Hourly Fee
      </Button>
      <Button
        variant={selectedForm == QuoteItemType.Flat ? 'contained' : 'outlined'}
        onClick={() => onChange(QuoteItemType.Flat)}
      >
        Flat/Fixed Fee
      </Button>
    </ButtonGroup>
  )
}

export type QuoteFormData = FlatFeeFormData | HourlyFeeFormData

export interface QuoteFormProps {
  onSubmit: (data: QuoteFormData) => Promise<boolean>
  quoteData?: QuoteFormData
  onClickCancelButton: () => void
}

const QuoteForm = ({
  onSubmit,
  quoteData = undefined,
  onClickCancelButton,
}: QuoteFormProps) => {
  const [formType, setFormType] = useState<QuoteItemType>(
    quoteData?.formType ?? QuoteItemType.Hourly,
  )
  return (
    <ItemBoundingBox variant="outlineBox" data-testid="quote-form">
      <Stack direction="row" spacing={2} mb={2}>
        <FormSelector
          selectedForm={formType}
          onChange={(formType) => setFormType(formType)}
        />
      </Stack>
      <Typography variant="body1" color="textSecondary" my={2}>
        Legal service fee quotes require a signed written fee agreement or
        engagement letter before work begins.
      </Typography>
      {formType === QuoteItemType.Hourly && (
        <HourlyFeeQuoteForm
          onSubmit={(newData: HourlyFeeFormData) => onSubmit(newData)}
          initialValues={quoteData as HourlyFeeFormData}
          onClickCancelButton={onClickCancelButton}
        />
      )}
      {formType === QuoteItemType.Flat && (
        <FlatFeeQuoteForm
          onSubmit={(newData: FlatFeeFormData) => onSubmit(newData)}
          initialValues={quoteData as FlatFeeFormData}
          onClickCancelButton={onClickCancelButton}
        />
      )}
    </ItemBoundingBox>
  )
}
export default QuoteForm
